import { BASE_URL } from "../services/client";

/**
 * 서버에 저장된 상대 경로(예: "/uploads/notice/x.png")를
 * 브라우저에서 접근 가능한 URL 로 변환한다.
 *
 * BASE_URL 은 항상 ".../api" 형태라 "/api" 를 떼면 서버 루트가 된다.
 * - 프로덕션: 프론트와 API 가 같은 오리진이라 결과가 상대경로와 동일
 * - 개발: 프론트(8815)와 API/정적파일(8810)이 다른 오리진이므로 절대 URL 이 된다
 * - 이미 http(s) 절대 URL 이면 그대로 둔다
 */
export const resolveServerUrl = (url: string) => {
  if (!url) return url;
  if (/^https?:\/\//i.test(url)) return url;
  const serverRoot = (BASE_URL || "").replace(/\/api\/?$/, "");
  return `${serverRoot}${url}`;
};

/**
 * HTML 문자열 안의 <img src="/uploads/..."> 들을 표시 가능한 URL 로 변환.
 * 개발 환경에서 프론트 포트로 접속해도 API 서버의 이미지가 보이게 한다.
 */
export const resolveUploadUrlsInHtml = (html: string) => {
  if (!html) return html;
  return html.replace(/src="(\/uploads\/[^"]*)"/g, (_, p) => `src="${resolveServerUrl(p)}"`);
};
